// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-section {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #f5f6f6;
}

.right-section:before {
    content: '';
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
    height: 20px;
    background: none;
    border-top: 4px solid #003c4f;
    border-radius: 10px 10px 0 0;
    transform: scaleY(0.5);
    z-index: 1;
}

.info-message {
  display: block;         /* Yer kaplamasını garanti eder */
  width: 100%;            /* Genişlik taşmasın */
  margin-bottom: 12px;    /* Diğer öğelerden ayrılmak için */
  background-color: #fef2f2;  /* örnek stil */
  padding: 8px;           /* içerik ile kenar arasında boşluk */
  border: 1px solid #fca5a5;
  border-radius: 4px;
  box-sizing: border-box; /* padding + border genişliği bozmasın */
}



.right-tabs {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ddd;
    width: 100%;
    margin: 15px 0 0 0;
    padding: 0;
    border-radius: 10px 10px 0 0;
    flex-shrink: 0;
    font-size: 14px;

}

.right-tab {
    flex: 1 1;
    padding: 10px 15px;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    transition: background-color 0.3s, border-bottom-color 0.3s;
    margin: 0;
    text-align: center;
    border-radius: 10px 10px 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: none;
}

.right-tab:hover {
    background-color: #e0e0e0;
}

.right-tab.active {
    border-bottom-color: #003c4f;
    background-color: #f5f6f6;
}

.right-tab-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background-color: #f5f6f6;
    margin-top: 10px;
    border-radius: 0 0 10px 10px;
    overflow: hidden;
    height: calc(100vh - 100px);
    width: 100%;
}

.scrollable-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 20px;
}

.references-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.reference-item {
    background: white;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    text-align: left;
    text-align: justify;
}

.reference-item h3 {
    margin: 0 0 10px 0;
    color: #333;
    font-size: 1.1em;
}

.reference-item p {
    margin: 5px 0;
    color: #666;
}

.reference-summary {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #eee;
    font-style: italic;
    color: #555;
}

@media screen and (max-width: 768px) {
    .right-tabs {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .right-tab {
        flex: 1 1 auto;
    }
}
/* Strategy List Styles */
.strategy-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px;
}

.strategy-item {
    background-color: #ffffff;
    padding: 8px 12px;
    border-radius: 20px;
    font-size: 14px;
    color: #333;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.strategy-number {
    display: none; /* Numara göstermek istemiyorsanız gizleyebilirsiniz */
}

.strategy-text {
    /* Ek stil gerekirse buraya ekleyebilirsiniz */
}
.article-link-container {
    margin: 10px 0;
    display: flex;
    gap: 8px;
    margin: 12px 0;
    flex-wrap: wrap;
}

.article-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #3c4f58;
    text-decoration: none;
    padding: 4px 8px;
    border: 1px solid #82a3d8;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    background-color: #f8fafc;
    transition: all 0.2s ease;
    min-height: 28px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.article-link:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
    color: #1e293b;
    transform: translateY(-1px);
}

.article-link:active {
    transform: translateY(0);
    background-color: #e2e8f0;
}

/* Bilgi mesajı için stil */
.info-message {
    background-color: rgba(255, 99, 71, 0.2); /* Şeffaf kırmızı arka plan */
    color: #d32f2f; /* Kırmızı yazı rengi */
    font-size: 14px;
    padding: 8px;
    margin-bottom: 10px;
    border-radius: 4px;
    text-align: center;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/RightTabs/RightTabs.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,4BAA4B;IAC5B,sBAAsB;IACtB,UAAU;AACd;;AAEA;EACE,cAAc,UAAU,iCAAiC;EACzD,WAAW,aAAa,sBAAsB;EAC9C,mBAAmB,KAAK,kCAAkC;EAC1D,yBAAyB,GAAG,eAAe;EAC3C,YAAY,YAAY,qCAAqC;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB,EAAE,wCAAwC;AAClE;;;;AAIA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,4BAA4B;IAC5B,cAAc;IACd,eAAe;;AAEnB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,2DAA2D;IAC3D,SAAS;IACT,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;AACA,yBAAyB;AACzB;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,aAAa,EAAE,sDAAsD;AACzE;;AAEA;IACI,8CAA8C;AAClD;AACA;IACI,cAAc;IAId,aAAa;IACb,QAAQ;IACR,cAAc;IACd,eAAe;AANnB;;AASA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,wCAAwC,EAAE,6BAA6B;IACvE,cAAc,EAAE,uBAAuB;IACvC,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":[".right-section {\r\n    width: 100%;\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n    background-color: #f5f6f6;\r\n}\r\n\r\n.right-section:before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 0;\r\n    right: 0;\r\n    height: 20px;\r\n    background: none;\r\n    border-top: 4px solid #003c4f;\r\n    border-radius: 10px 10px 0 0;\r\n    transform: scaleY(0.5);\r\n    z-index: 1;\r\n}\r\n\r\n.info-message {\r\n  display: block;         /* Yer kaplamasını garanti eder */\r\n  width: 100%;            /* Genişlik taşmasın */\r\n  margin-bottom: 12px;    /* Diğer öğelerden ayrılmak için */\r\n  background-color: #fef2f2;  /* örnek stil */\r\n  padding: 8px;           /* içerik ile kenar arasında boşluk */\r\n  border: 1px solid #fca5a5;\r\n  border-radius: 4px;\r\n  box-sizing: border-box; /* padding + border genişliği bozmasın */\r\n}\r\n\r\n\r\n\r\n.right-tabs {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-bottom: 1px solid #ddd;\r\n    width: 100%;\r\n    margin: 15px 0 0 0;\r\n    padding: 0;\r\n    border-radius: 10px 10px 0 0;\r\n    flex-shrink: 0;\r\n    font-size: 14px;\r\n\r\n}\r\n\r\n.right-tab {\r\n    flex: 1;\r\n    padding: 10px 15px;\r\n    border: none;\r\n    border-bottom: 3px solid transparent;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s, border-bottom-color 0.3s;\r\n    margin: 0;\r\n    text-align: center;\r\n    border-radius: 10px 10px 0 0;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    background: none;\r\n}\r\n\r\n.right-tab:hover {\r\n    background-color: #e0e0e0;\r\n}\r\n\r\n.right-tab.active {\r\n    border-bottom-color: #003c4f;\r\n    background-color: #f5f6f6;\r\n}\r\n\r\n.right-tab-content {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #f5f6f6;\r\n    margin-top: 10px;\r\n    border-radius: 0 0 10px 10px;\r\n    overflow: hidden;\r\n    height: calc(100vh - 100px);\r\n    width: 100%;\r\n}\r\n\r\n.scrollable-content {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 20px;\r\n}\r\n\r\n.references-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.reference-item {\r\n    background: white;\r\n    padding: 15px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\r\n    text-align: left;\r\n    text-align: justify;\r\n}\r\n\r\n.reference-item h3 {\r\n    margin: 0 0 10px 0;\r\n    color: #333;\r\n    font-size: 1.1em;\r\n}\r\n\r\n.reference-item p {\r\n    margin: 5px 0;\r\n    color: #666;\r\n}\r\n\r\n.reference-summary {\r\n    margin-top: 10px;\r\n    padding-top: 10px;\r\n    border-top: 1px solid #eee;\r\n    font-style: italic;\r\n    color: #555;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    .right-tabs {\r\n        flex-direction: row;\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .right-tab {\r\n        flex: 1 1 auto;\r\n    }\r\n}\r\n/* Strategy List Styles */\r\n.strategy-list {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    padding: 10px;\r\n}\r\n\r\n.strategy-item {\r\n    background-color: #ffffff;\r\n    padding: 8px 12px;\r\n    border-radius: 20px;\r\n    font-size: 14px;\r\n    color: #333;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\r\n}\r\n\r\n.strategy-number {\r\n    display: none; /* Numara göstermek istemiyorsanız gizleyebilirsiniz */\r\n}\r\n\r\n.strategy-text {\r\n    /* Ek stil gerekirse buraya ekleyebilirsiniz */\r\n}\r\n.article-link-container {\r\n    margin: 10px 0;\r\n}\r\n\r\n.article-link-container {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin: 12px 0;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.article-link {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #3c4f58;\r\n    text-decoration: none;\r\n    padding: 4px 8px;\r\n    border: 1px solid #82a3d8;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    background-color: #f8fafc;\r\n    transition: all 0.2s ease;\r\n    min-height: 28px;\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.article-link:hover {\r\n    background-color: #f1f5f9;\r\n    border-color: #cbd5e1;\r\n    color: #1e293b;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.article-link:active {\r\n    transform: translateY(0);\r\n    background-color: #e2e8f0;\r\n}\r\n\r\n/* Bilgi mesajı için stil */\r\n.info-message {\r\n    background-color: rgba(255, 99, 71, 0.2); /* Şeffaf kırmızı arka plan */\r\n    color: #d32f2f; /* Kırmızı yazı rengi */\r\n    font-size: 14px;\r\n    padding: 8px;\r\n    margin-bottom: 10px;\r\n    border-radius: 4px;\r\n    text-align: center;\r\n    font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
